// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"M_-z"};